

















import Vue from 'vue';
export default Vue.extend(
  {
    name: 'Dialog',
    props: {
      dialogMessage: {
        type: String,
        default: '',
      },
    },
  },
);
